import { useState } from "react";
import { useData } from "@/hooks/useData";
import { TransportDistribution } from "@/types/transport-distribution/transport-distribution.types";
import { useTransportDistributionFilters } from "./useTransportDistributionFilters";

export const useTransportDistributionTable = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [showArchived, setShowArchived] = useState(false);
  const [vehicleTypeFilters, setVehicleTypeFilters] = useState<string[]>([]);

  const {
    data: transportDistributions,
    loading,
    refetch,
  } = useData<TransportDistribution>({
    collectionName: "setup_transportDistributions",
  });

  const { filteredDistributions, getUniqueOptions } = useTransportDistributionFilters({
    transportDistributions,
    searchTerm,
    showArchived,
    vehicleTypeFilters,
  });

  const clearFilters = () => {
    setSearchTerm("");
    setVehicleTypeFilters([]);
  };

  const vehicleTypeOptions = getUniqueOptions("vehicleType");

  return {
    transportDistributions,
    filteredDistributions,
    loading,
    refetch,
    searchTerm,
    setSearchTerm,
    showArchived,
    setShowArchived,
    vehicleTypeFilters,
    setVehicleTypeFilters,
    clearFilters,
    vehicleTypeOptions,
  };
}; 